<!-- Copyright ©2026 Hitachi High-Tech Corporation All Rights Reserved. -->
<ng-container *ngIf="!hasError">
  <ng-container *ngIf="!isLoading; else loading">
    <div class="layout">
      <!-- molecule List -->
      <aside>
        <div><label class="gender">Sex:&nbsp;</label>{{ gender }}</div>
        <app-hce-stats-table
          [columnTitles]="moleculeDisplayedColumnLabels"
          [columnKeys]="moleculeDisplayedColumns"
          [data]="moleculeListData"
        ></app-hce-stats-table>
      </aside>
      <!-- chart -->
      <main class="right">
        <!-- control -->
        <div>
          <table class="d-flex justify-content-start align-items-center">
            <tr>
              <td>
                <label for="max_xaxis"><p>Change x-axis max:</p></label>
              </td>
              <td>
                <div style="margin-top: 0.9rem">
                  <form>
                    <app-dropdown
                      [label]="''"
                      [options]="dropdownOptions"
                      (selectedValueChange)="onChangeXAxis($event)"
                      [selectedValue]="selectionValue"
                      [formControlObj]="selectPanelName"
                    ></app-dropdown>
                  </form>
                </div>
              </td>
            </tr>
          </table>
          <app-buttons
            [isDisabled]="false"
            [name]="btnName"
            [buttonType]="btnMatStroked"
            [buttonStyle]="btnStyleStroked"
            class="col-md-2"
            (buttonClickEvent)="onClickChangeYAxis()"
          ></app-buttons>
        </div>
        <!-- Molecule Size Distribution -->
        <div chass="molecule-size-distribution">
          <app-hce-stats-histogram
            [title]="'Molecule Size Distribution'"
            [xTicks]="moleculeSizeDistributionXTicks"
            [yTicks]="moleculeSizeDistributionYTicks"
            [xAxisTitle]="'Molecule Length (Kb)'"
            [yAxisTitle]="isYAxisPV ? 'Molecule Mass (% of total)' : 'Molecule Mass (count)'"
            [data]="moleculeSizeDistributionData ?? []"
            [yMin]="0"
            [barColor]="barColor"
            [barWidthPx]="10"
          ></app-hce-stats-histogram>
        </div>
        <!-- Interval Count Distribution -->
        <div class="interval-count-distribution">
          <app-hce-stats-histogram
            [title]="'Interval Count Distribution'"
            [xTicks]="intervalCountDistributionXTicks"
            [yTicks]="intervalCountDistributionYTicks"
            [xAxisTitle]="'Number of Intervals'"
            [yAxisTitle]="'Molecule Mass (count)'"
            [data]="intervalCountDistributionData ?? []"
            [barColor]="barColor"
            [barWidthPx]="4"
          ></app-hce-stats-histogram>
        </div>
      </main>
    </div>
  </ng-container>

  <ng-template #loading>
    <div class="loader" aria-live="polite" aria-busy="true">
      <mat-spinner></mat-spinner>
    </div>
  </ng-template>
</ng-container>
